export const protocol_set = {
  Download_complete_and_detailed_mapping_file: "Download complete and detailed mapping file",
  Download_complete_and_simplified_mapping_file: "Download complete and simplified mapping file",
  Download_filtered_and_simplified_mapping_file: "Download filtered and simplified mapping file",
  Draft_Name: "Draft Name",
  protocol_question: {
    Are_you_sure_you_want_to_delete_this_protocol_question: "Are you sure you want to delete this protocol question?",
    are_you_sure_you_want_to_duplicate_this_protocol_question:
      "Are you sure you want to duplicate this protocol question?",
    Basic_information: "Basic information",
    changed: "changed",
    Content: "Content",
    Content_is_required: "Content is required",
    Create_protocol_question: "Create new protocol question",
    created: "created",
    deleted: "deleted",
    erm_mapping_note: "ERM Mapping Note",
    Export_to_file: "Export to file",
    Internal_audit: "Internal audit",
    Link_a_requirement: "Link a requirement",
    link_a_protocol_question: "Link a protocol question",
    link_protocol_questions: {
      Back_to_Linking_Page: "Back to the Linking Page",
      Back_to_the_Protocol_Questions_List: "Back to the Protocol Questions List",
      Back_to_the_Requirements_List: "Back to the Requirements List",
      Link_protocol_questions_to_requirements: "Link protocol questions to a requirement",
      Requirement_info: "Requirement",
      This_requirement_is_already_mapped_to: "This requirement is already mapped to:",
    },
    link_requirements: {
      Is_mapped: "Is mapped",
      Link: "Link",
      Name_of_the_standard: "Name of the standard",
      Protocol_question_is_in_edit_mode: "Protocol question is in edit mode, changes wont be saved.",
      Search_results: "Search results",
      Search_similarities_in_protocol_questions: "Search similarities in protocol questions",
      Select_filters: "Select filters",
      Smart_search_mode: "Smart search mode",
      You_have_to_select_at_least_one_requirement: "You have to select at least one requirement",
    },
    internal_note: "Internal SME note",
    Link_requirements: "Link requirements",
    linked: "linked",
    List_of_mapped_requirements: "List of mapped requirements",
    list_of_related_protocol_questions: "List of related protocol questions",
    Protocol_question: "Protocol question",
    Protocol_question_info: "Protocol question info",
    Protocol_question_list: "Protocol question list",
    reorder: {
      No_protocol_questions_found_for_this_theme_and_subtheme:
        "No protocol questions found for this theme and subtheme.",
      Reorder: "Reorder",
      Reorder_protocol_questions: "Reorder protocol questions",
      You_need_to_select_a_theme_and_subtheme: "You need to select a theme and subtheme to reorder protocol questions.",
      You_want_to_proceed_without_saving_changes: "You want to proceed without saving? All changes will be lost.",
    },
    Requirement_will_be_unlinked_from_the_protocol_question: "Requirement will be unlinked from the protocol question.",
    protocol_questions_will_be_unlinked: "Protocol questions will be unlinked",
    Save_protocol_question: "Save protocol question",
    Scope_of_applicability: "Scope of applicability",
    Scope_of_applicability_is_required: "Scope of applicability is required",
    split: "split",
    Stakeholder_engagement: "Stakeholder engagement",
    Standard_structure: "Standard structure",
    Start_a_new_draft: "Start a new draft",
    Sub_theme_is_required: "Sub theme is required",
    Subtheme: "Subtheme",
    Theme: "Theme",
    Theme_is_required: "Theme is required",
    This_action_cannot_be_undone: "This action cannot be undone",
    This_file_will_contain_all_protocol_questions_in_this_mapping_set:
      "This file will contain all protocol questions in this mapping set.",
    This_file_will_contain_protocol_questions_based_on_all_the_customizations_and_filters_you_have_applied:
      "This file will contain protocol questions based on all the customizations and filters you have applied.",
    This_mapping_draft_is_currently_in_review:
      "This mapping draft is currently in review. Making this change will cancel the review status of the draft.",
    This_protocol_question_is_also_linked_to: "This protocol question is also linked to",
    Unlink: "Unlink",
    unlinked: "unlinked",
    You_will_be_redirected_to_the_newly_created_protocol_question:
      "You will be redirected to the newly created protocol question.",
  },
  Protocol_Question: "Protocol Question",
  Protocol_questions: "Protocol Questions",
  Protocol_set: "Protocol Set",
  question_id: "Question ID",
  related_requirements: "Related Requirements",
  review_draft: {
    Approve_and_close: "Approve and close",
    Are_you_sure_you_want_to_publish_this_draft: "Are you sure you want to publish this draft?",
    at: "at",
    Created_by: "Created by",
    Download_draft_changes: "Download draft changes",
    Draft_cannot_be_published_by_the_same_user:
      "Draft cannot be published by the same user who submitted it for review.",
    Draft_has_already_been_submitted: "Draft has already been submitted for approval.",
    Draft_needs_to_be_submitted_for_review_before_publishing:
      "Draft needs to be submitted for review before publishing.",
    Draft_review: "Draft review",
    No_further_edits_will_be_possible_after_publishing: "No further edits will be possible after publishing.",
    on: "on",
    page_description: {
      Note: "Note: While in the pending approval state, any further changes to a protocol question in the draft will revert the pending approval state.",
      Please_press_download_draft:
        'Please press "Download draft changes" to get an excel representation of the protocol mapping changes between this draft and the last published version.',
      The_flow_for_mapping: "The flow for mapping changes is as follows: Draft -> Pending Approval -> Publish.",
      This_is_the_page_for_draft:
        "This is the page for draft review and approval. Once approved by another mapping tool user, the draft will be published making it saved with no further changes possible.",
    },
    Published_by: "Published by",
    Review_a_draft: "Review a draft",
    Submit_for_approval: "Submit for approval",
    Submitted_by: "Submitted by",
  },
  scope_of_applicability: "Scope of applicability",
  Search_protocol_questions: "Search protocol questions",
  Search_requirements: "Search requirements",
  Search_standards: "Search standards",
  standards: {
    Add_New_Standard: "Add New Standard",
    All_Clients: "All Clients",
    Back_to_the_Standards_List: "Back to the Standards List",
    Body: "Body",
    Create_New_Standard: "Create New Standard",
    Date: "Date",
    Edit_Standard: "Edit Standard",
    Full_name: "Full name",
    ID: "ID",
    Link: "Link",
    Publish_date: "Publish date",
    Save_Standard: "Save Standard",
    Standard_body: "Standard body",
    Standard_ID: "Standard ID",
    Tenants: "Tenants",
    Version: "Version",
  },
  Start_a_draft: "Start a draft",
  Start_draft_description: "Start a new draft and switch to edit mode",
  Starting_new_draft_process: "Starting New Draft Process",
  sub_theme: "Sub Theme",
  theme: "Theme",
} as const;
